<template>
    <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
               <h1>PAGE NOT FOUND</h1>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>

    export default {
        name: "NotFound",
        data: () => ({

        })
    }
</script>

<style scoped>

</style>